import { render, staticRenderFns } from "./SectionCard.vue?vue&type=template&id=3a17330c&scoped=true"
import script from "./SectionCard.vue?vue&type=script&lang=js"
export * from "./SectionCard.vue?vue&type=script&lang=js"
import style0 from "./SectionCard.vue?vue&type=style&index=0&id=3a17330c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a17330c",
  null
  
)

export default component.exports